import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControlLabel,
  FormGroup,
  Switch,
  TextField,
  Typography
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useState } from 'react';
import { IdentityField } from 'components/form/IdentityField';
import { TextFieldAdapter } from 'components/form/TextFieldAdapter';
import { AutocompleteAdapter } from 'components/form/AutocompleteAdapter';
import ReactFinalForm from 'components/form/ReactFinalForm';
import { MonthPickerAdapter } from 'components/form/MonthPickerAdapter'; // <-- importa il fratello custom!

const monthYearOptions = [
  { id: 1, code: 'Mensile' },
  { id: 2, code: 'Annuale' }
];

export const MaintenanceMonthDataDialog = ({
  openCalendar,
  onCancel,
  onSubmit
}: {
  openCalendar: boolean;
  onCancel: () => void;
  onSubmit: (values: any) => void;
}) => {
  const { t } = useTranslation();
  const [programmed, setProgrammed] = useState(false);

  return (
    <Dialog open={openCalendar} onClose={onCancel}>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <DialogTitle>Seleziona Mese</DialogTitle>
        <DialogContent sx={{ width: '400px' }}>
          <ReactFinalForm
            onSubmit={onSubmit}
            formId="addMaintenanceMultipleDates"
            hideControls={true}>
            <FormGroup>
              <FormControlLabel
                control={
                  <Switch
                    className="m-2"
                    checked={programmed}
                    onChange={(e) => setProgrammed(e.target.checked)}
                  />
                }
                label={
                  <Typography color="text.primary">
                    <b>{t(`entities.maintenance.data-programmed`)}</b>
                  </Typography>
                }
              />
            </FormGroup>
            <div className="w-full flex justify-center">
              <div className="w-[400px] space-y-4">
                <div className="w-full">
                  <IdentityField
                    name="month"
                    component={MonthPickerAdapter}
                    label={programmed ? 'Inizia dal mese' : t('global.month')}
                    required={true}
                  />
                </div>

                {programmed && (
                  <>
                    <div className="w-full">
                      <IdentityField
                        name="rep_unit"
                        component={AutocompleteAdapter}
                        options={monthYearOptions}
                        label="Tipologia ripetizione"
                        type="text"
                      />
                    </div>
                    <div className="w-full">
                      <IdentityField
                        name="rep_frequency"
                        component={TextFieldAdapter}
                        label="Frequenza ripetizione"
                        placeholder="Ogni (x) mesi/anni..."
                        type="number"
                      />
                    </div>

                    <div className="w-full">
                      <IdentityField
                        name="end_programmed"
                        component={MonthPickerAdapter}
                        label={'Fino al mese'}
                        required={true}
                      />
                    </div>
                  </>
                )}
              </div>
            </div>
          </ReactFinalForm>
        </DialogContent>
        <DialogActions>
          <Button onClick={onCancel} color="error">
            {t(`actions.cancel`)}
          </Button>
          <Button type="submit" form="addMaintenanceMultipleDates">
            {t(`actions.confirm`)}
          </Button>
        </DialogActions>
      </LocalizationProvider>
    </Dialog>
  );
};
